import { Injectable } from '@angular/core';
import { first, Observable, Subject } from 'rxjs';
import { ContinuousCourseOffering } from 'src/app/models/continuous-course-offering';

@Injectable()
export class ContinuousCourseOfferingActionsService {
    private addContinuousCourseOfferingAction = new Subject<void>();
    private editContinuousCourseOfferingAction = new Subject<ContinuousCourseOffering>();
    private deleteContinuousCourseOfferingAction = new Subject<ContinuousCourseOffering>();
    private editContinuousCourseOfferingTutorRoleAction = new Subject<ContinuousCourseOffering>();
    private refreshContinuousCourseOfferingAction = new Subject<void>();
    private refreshCompleteAction = new Subject<void>();

    addContinuousCourseOffering$ = this.addContinuousCourseOfferingAction.asObservable();
    editContinuousCourseOffering$ = this.editContinuousCourseOfferingAction.asObservable();
    deleteContinuousCourseOffering$ = this.deleteContinuousCourseOfferingAction.asObservable();
    editContinuousCourseOfferingTutorRole$ = this.editContinuousCourseOfferingTutorRoleAction.asObservable();
    refreshContinuousCourseOfferings$ = this.refreshContinuousCourseOfferingAction.asObservable();
    refreshComplete$ = this.refreshCompleteAction.asObservable();

    constructor() { }
    
    requestContinuousCourseOfferingAdd(): Observable<void> {
        return new Observable<void>((observer) => {
          this.addContinuousCourseOfferingAction.next();
    
          this.refreshComplete$.pipe(first()).subscribe(() => {
            observer.next();
            observer.complete();
          });
        });
    }

    requestContinuousCourseOfferingEdit(ce: ContinuousCourseOffering) {
        this.editContinuousCourseOfferingAction.next(ce);
    }

    requestContinuousCourseOfferingDelete(pe: ContinuousCourseOffering) {
        this.deleteContinuousCourseOfferingAction.next(pe);
    }

    requestContinuousCourseOfferingTutorRoleEdit(ce: ContinuousCourseOffering) {
        this.editContinuousCourseOfferingTutorRoleAction.next(ce);
    }

    requestContinuousCourseOfferingsRefresh() {
        this.refreshContinuousCourseOfferingAction.next();
    }

    notifyRefreshComplete() {
        this.refreshCompleteAction.next();
    }
}
